/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {DriverObjectInstance} from "../models/driver-object-instance";
import {DriverObjectService} from "../services/driver-object.service";
import { Input, Injectable } from "@angular/core";
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";
import {PAGING_ITEMS_PER_PAGE} from "../app-constants";
import { PagedResults } from "app/models/paged-results";

@Injectable()
//@Input() KHT - using the @Input() tag breaks certain resolvers after Angular 12 update
export class DriverObjectInstancesPagingResolver implements Resolve<PagedResults<DriverObjectInstance>> {

  constructor(
    private mDriverObjectService: DriverObjectService
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<PagedResults<DriverObjectInstance>> {
    try {
      return await this.mDriverObjectService.getAllDriverObjectInstancesForPaging(0, PAGING_ITEMS_PER_PAGE, "ASC", "");
    } catch (error) {
      console.error("Problem resolving Driver Object Instances... Error: " + error, error);
    }
  }

}
